import { string } from 'yup'

export const userSchema = {
  name: string().required('O nome do usuário é obrigatório'),
  email: string().email().required('O e-mail é obrigatório')
}
